module.exports = __webpack_public_path__ + "a88486600c0fab6d2d3d9c4af17f8a12.svg";